import React, { Component } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import { Link } from "react-router-dom";
import Print from "react-to-print";
import moment from "moment";
import ReactSelect from "react-select";
// import ReactTooltip from "react-tooltip";
import html2canvas from "html2canvas";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
// require("datatables.net-buttons")();
// require("datatables.net-buttons/js/buttons.colVis.js")();
let FormatNumberTwoDecimals = (num) => {
  num = (num + "").replace(/[^[.\d]/g, "");
  return Number(num).toFixed(2);
};
export class InvoiceDetailsPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice: { id: -1 },
      company_info: {
        name: "",
        email: "",
        address_line_1: "",
        address_line_2: null,
        city: "",
        state: "",
        zip: "",
        telephone: "",
        fax: "",
        website: "",
        image_link: "",
      },
      client: { id: 0 },
      line_items: [],
      billed_times: [],
      authenticated_senders: [],
      client_contacts: [],
    };
    this.myRef = React.createRef();
  }
  //this.props.location.state
  componentDidMount() {
    if (
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.invoice &&
      this.props.location.state.company_info &&
      this.props.location.state.client &&
      this.props.location.state.billed_times &&
      this.props.location.state.line_items
    )
      this.setState(
        {
          invoice: this.props.location.state.invoice,
          company_info: this.props.location.state.company_info,
          client: this.props.location.state.client,
          line_items: this.props.location.state.line_items,
          billed_times: this.props.location.state.billed_times,
        },
        () => {
          this.GetInvoice();
          this.GetAuthenticatedSenders();
        },
      );
    else {
      this.setState(
        {
          invoice: this.props.location.state.invoice,
          client: this.props.location.state.client,
        },
        () => {
          this.GetInvoice();
          this.GetAuthenticatedSenders();
        },
      );
    }
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 2);
  }
  GetInvoiceInformation = () => {};
  GetCompany = (e) => {
    const topThis = this;
    let dataObj = { "x-access-token": this.props.authToken };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/companies/get", dataObj)
      .then(function (response) {
        if (response["data"]["status"] === "Error") {
          topThis.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          topThis.setState({ company_info: response["data"]["data"][0] });
        }
      })
      .catch(function (error) {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          topThis.props.setRelogRequired(true);
        }
        topThis.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(function () {});
  };
  GetContacts = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/client-contacts/get", {
      "x-access-token": this.props.authToken,
      client_id: this.state.client.id,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ client_contacts: response["data"]["client_contacts"] }, () => {});
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetAuthenticatedSenders = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/authenticated-senders/get", {
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ authenticated_senders: response["data"]["data"] });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetClient = (event) => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/clients/get", {
      "x-access-token": this.props.authToken,

      cid: this.state.client.id,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ client: response["data"]["client"][0] }, this.GetContacts);
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetInvoiceLineItems = (e) => {
    const topThis = this;
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/get/line-items/by-invoice", {
      "x-access-token": this.props.authToken,

      invoice_id: this.state.invoice.id,
    })
      .then(function (response) {
        if (response["data"]["status"] === "Error") {
          topThis.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          topThis.setState({ line_items: response["data"]["data"] }, function () {});
        }
      })
      .catch(function (error) {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          topThis.props.setRelogRequired(true);
        }
        topThis.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(function () {
        $(".hide-until-item-select").hide();
      });
  };
  SendInvoiceViaEmail = () => {
    if (this.state.email.to.length === 0) {
      this.props.MakeNotification("warning", "Please select at least one recipient");
      return;
    }
    $("#email_invoice").prop("disabled", true);
    html2canvas($("#invoice-preview-to-print")[0], { scale: 2, allowTaint: false, useCORS: true }).then((canvas) => {
      canvas.toBlob((blob) => {
        let fd = new FormData();
        fd.append("file", blob, this.state.client.tag + "-" + this.state.invoice.tag);
        //saveAs(blob, "pretty image.png");
        Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/upload", fd, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
          .then((response) => {
            if (response["data"]["status"] === "Error") {
              this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
            }
            if (response["data"]["status"] === "success") {
              Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/email", {
                "x-access-token": this.props.authToken,
                to_emails: this.state.email.to,
                from_email: this.state.email.from,
                invoice_id: this.state.invoice.id,
                now: moment().format("YYYY-MM-DD HH:mm:ss"),
              })
                .then((response) => {
                  if (response["data"]["status"] === "Error") {
                    this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
                  }
                  if (response["data"]["status"] === "success") {
                    this.props.MakeNotification("success", response["data"]["message"] || "Email sent!");
                    $("#offCanvasContacts").delay(1000).hide(200);
                  }
                })
                .catch((error) => {
                  //handle errors
                  console.log(error);
                  if (error.response && error.response.status === 401) {
                    this.props.setRelogRequired(true);
                  }
                  this.props.MakeNotification("error", "There was an error. Please try again.");
                })
                .then(() => {
                  $("#email_invoice").prop("disabled", false);
                });
            }
          })
          .catch((error) => {
            //handle errors
            console.log(error);
            if (error.response && error.response.status === 401) {
              this.props.setRelogRequired(true);
            }
            this.props.MakeNotification("error", "There was an error. Please try again.");
          })
          .then(() => {});
      });
    });
    //var canvas = $("#invoice-preview-to-print")[0];
  };
  GetInvoice = (e) => {
    let topThis = this;
    this.GetCompany();
    this.GetClient();
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/get", {
      "x-access-token": this.props.authToken,

      invoice_id: this.state.invoice.id,
    })
      .then(function (response) {
        if (response["data"]["status"] === "Error") {
          topThis.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          topThis.setState({ invoice: response["data"]["data"] }, function () {});
        }
      })
      .catch(function (error) {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          topThis.props.setRelogRequired(true);
        }
        topThis.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(function () {
        $(".hide-until-item-select").hide();
        topThis.GetInvoiceLineItems();
      });
  };

  //----------------------------|END PREPS|----------------------------\\
  render() {
    return (
      <div className="container">
        <div className="text-left m-1 row">
          <div className="col-md-4 col-sm-6 col-6 text-center">
            <div className="btn-group">
              <button type="button" className="btn btn-primary mb-1 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <FontAwesomeIcon icon="arrow-alt-circle-left" className="pe-none" />
                &nbsp;Go Back
              </button>
              <div className="dropdown-menu" style={{ position: "absolute", inset: "0px auto auto 0px", margin: "0px", transform: "translate(0px, 35px)", dataPopperPlacement: "bottom-start" }}>
                <Link to={{ pathname: "/invoicing", state: { client_id: this.state.client.id, invoice_id: this.state.invoice.id } }}>
                  <span className="dropdown-item clickable">
                    <FontAwesomeIcon icon="edit" />
                    &nbsp;To Invoice
                  </span>
                </Link>
                {/* <span
                  className="dropdown-item clickable"
                  onClick={() => {
                    this.props.GoToClientDetails(this.state.task.client_id);
                  }}
                >
                  <FontAwesomeIcon className="pe-none" icon="user-circle" />
                  &nbsp; Go To Client Details
                </span> */}
                <Link to={{ pathname: "/client-details", state: { client_id: this.state.client.id } }}>
                  <span className="dropdown-item clickable">
                    <FontAwesomeIcon className="pe-none" icon="user-circle" />
                    &nbsp;To Client
                  </span>
                </Link>

                {/* <span className="dropdown-item clickable">Something else here</span> */}

                <Link to={{ pathname: "/time-sheet" }}>
                  <span className="dropdown-item clickable">
                    <FontAwesomeIcon className="pe-none" icon="clock" />
                    &nbsp;To Time Sheet
                  </span>
                </Link>

                <Link to={{ pathname: "/task-board" }}>
                  <span className="dropdown-item clickable">
                    <FontAwesomeIcon className="pe-none" icon="tasks" />
                    &nbsp;To My Board
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-6  text-center">
            <Print
              trigger={() => (
                <button className="btn btn-warning">
                  <FontAwesomeIcon icon="print" /> &nbsp;Print Invoice
                </button>
              )}
              content={() => $("#invoice-preview-to-print")[0]}
            />
          </div>
          <div className="col-md-4 col-sm-6 col-6 text-center">
            <button className="btn btn-secondary" onClick={this.PrepEmailInvoice} data-bs-toggle="offcanvas" data-bs-target="#offCanvasContacts" aria-controls="offCanvasContacts">
              <FontAwesomeIcon icon="envelope" className="pe-none" /> &nbsp;Email Invoice
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div id="invoice-preview-to-print" style={{ width: "210mm", margin: "auto", pageBreakAfter: "auto" }}>
            <div className="invoice-body">
              <div className="card m-2" style={{ minHeight: "260mm", pageBreakAfter: "always" }}>
                <div className="card-body m-2">
                  <div className="row">
                    {this.state.company_info.invoice_image_type === 0 ? (
                      <div className="col-md-5" style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                        <div style={{ maxWidth: "105px", display: "inline-block" }}>
                          {this.state.company_info.image_link ? (
                            <img
                              crossOrigin="anonymous"
                              src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.state.company_info.image_link}
                              style={{ maxWidth: "95px", maxHeight: "99%" }}
                              id="user-info-image"
                              className="img-fluid mb-2"
                              alt="User"
                            />
                          ) : null}
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "15px" }}>
                          <b>{this.state.company_info.name ? this.state.company_info.name : null}</b>
                          <br></br>
                          {this.state.company_info.address_line_1 ? this.state.company_info.address_line_1 : null}
                          <br></br>
                          {this.state.company_info.address_line_2 === "" ? this.state.company_info.address_line_2 : null}
                          {this.state.company_info.city}, {this.state.company_info.state} {this.state.company_info.zip}
                          <br></br>
                        </div>
                      </div>
                    ) : null}
                    {this.state.company_info.invoice_image_type === 1 ? (
                      <div className="col-md-5" style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                        <div className="row">
                          <div className="col-md-12">
                            <div style={{ maxWidth: "100%", display: "inline-block" }}>
                              {this.state.company_info.image_link ? (
                                <img
                                  crossOrigin="anonymous"
                                  src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.state.company_info.image_link}
                                  style={{ maxWidth: "100%", maxHeight: "99%" }}
                                  id="user-info-image"
                                  className="img-fluid mb-2"
                                  alt="User"
                                />
                              ) : null}
                            </div>

                            <div style={{ display: "inline-block", marginLeft: "15px" }}>
                              <b>{this.state.company_info.name ? this.state.company_info.name : null}</b>
                              <br></br>
                              {this.state.company_info.address_line_1 ? this.state.company_info.address_line_1 : null}
                              <br></br>
                              {this.state.company_info.address_line_2 === "" ? this.state.company_info.address_line_2 : null}
                              {this.state.company_info.city}, {this.state.company_info.state} {this.state.company_info.zip}
                              <br></br>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-md-2 text-center">
                      <h3>INVOICE</h3>
                    </div>
                    <div className="col-md-2 text-md-end" style={{ textAlign: "right !important", fontSize: "12px" }}>
                      <div>
                        <b>Telephone:</b>
                        <br></br>
                        <b>Fax:</b>
                        <br></br>
                        <b>Website:</b>
                        <br></br>
                        <br></br>
                        <br></br>
                        <b>Invoice:</b>
                        <br></br>
                        <b>Invoice Date:</b>
                        <br></br>
                        <b>Due Date:</b>
                      </div>
                    </div>
                    <div className="col-md-3 text-md-end" style={{ fontSize: "12px" }}>
                      <div>{this.state.company_info.telephone || <br />}</div>
                      <div>{this.state.company_info.fax || <br />}</div>
                      <div>{this.state.company_info.website || <br />}</div>
                      <br></br>
                      <br></br>
                      <div>{this.state.invoice && this.state.invoice.id === -1 ? "Not yet saved" : <strong># {this.state.invoice.name}</strong>}</div>
                      <div>{moment.utc(this.props.MakeDateTimeReadable(this.state.invoice.invoiced_at)).format("LL")}</div>
                      <div>{moment.utc(this.props.MakeDateTimeReadable(this.state.invoice.due_at)).format("LL")}</div>
                    </div>
                  </div>
                  <hr className="my-4"></hr>
                  <div className="row mb-4" style={{ marginLeft: ".9in" }}>
                    <div className="col-md-6">
                      {/* <div className="text-muted">Client</div> */}
                      <strong>{this.state.client.name}</strong>
                      <p>
                        {this.state.client.address_line_1}
                        <br></br>
                        {this.state.client.address_line_2 === "" ? null : (
                          <span>
                            {this.state.client.address_line_2}
                            <br></br>
                          </span>
                        )}
                        {this.state.client.city ? this.state.client.city + ", " + this.state.client.state + " " + this.state.client.zip : ""}
                        {/* {this.state.client.city}, {this.state.client.state} {this.state.client.zip} <br></br> */}
                        <br></br>
                      </p>
                    </div>
                    <div className="col-md-6 text-md-end">
                      {/* <div className="text-muted">Payment To</div>
                          <strong>Spark LLC</strong>
                          <p>
                            354 Roy Alley <br></br>
                            Denver <br></br>
                            80202 <br></br>
                            USA <br></br>
                            <a href="#">info@spark.com</a>
                          </p> */}
                    </div>
                  </div>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Description</th>
                        {/* <th>Quantity</th> */}
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.line_items.map((e, i) => {
                        return (
                          <tr key={i}>
                            <td>{e.item_description}</td>
                            {/* <td>2</td> */}
                            <td className="text-end">{this.props.FormatNumberToCurrency(e.total)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total:</th>
                        <th className="text-end">{this.state.line_items.length > 0 ? this.props.FormatNumberToCurrency(this.state.line_items.reduce((a, b) => a + b.total, 0)) : null}</th>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    className="text-center"
                    dangerouslySetInnerHTML={{
                      __html:
                        this.state.company_info.invoice_footer_text ||
                        `<p className="text-sm">
                          <strong>Thank you for your business!</strong>
                        </p>`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="card m-2">
                <div className="card-body m-2">
                  <div className="row">
                    {this.state.company_info.invoice_image_type === 0 ? (
                      <div className="col-md-5" style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                        <div style={{ maxWidth: "105px", display: "inline-block" }}>
                          {this.state.company_info.image_link ? (
                            <img
                              crossOrigin="anonymous"
                              src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.state.company_info.image_link}
                              style={{ maxWidth: "95px", maxHeight: "99%" }}
                              id="user-info-image"
                              className="img-fluid mb-2"
                              alt="User"
                            />
                          ) : null}
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "15px" }}>
                          <b>{this.state.company_info.name ? this.state.company_info.name : null}</b>
                          <br></br>
                          {this.state.company_info.address_line_1 ? this.state.company_info.address_line_1 : null}
                          <br></br>
                          {this.state.company_info.address_line_2 === "" ? this.state.company_info.address_line_2 : null}
                          {this.state.company_info.city}, {this.state.company_info.state} {this.state.company_info.zip}
                          <br></br>
                        </div>
                      </div>
                    ) : null}
                    {this.state.company_info.invoice_image_type === 1 ? (
                      <div className="col-md-5" style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                        <div className="row">
                          <div className="col-md-12">
                            <div style={{ maxWidth: "100%", display: "inline-block" }}>
                              {this.state.company_info.image_link ? (
                                <img
                                  crossOrigin="anonymous"
                                  src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + this.state.company_info.image_link}
                                  style={{ maxWidth: "100%", maxHeight: "99%" }}
                                  id="user-info-image"
                                  className="img-fluid mb-2"
                                  alt="User"
                                />
                              ) : null}
                            </div>

                            <div style={{ display: "inline-block", marginLeft: "15px" }}>
                              <b>{this.state.company_info.name ? this.state.company_info.name : null}</b>
                              <br></br>
                              {this.state.company_info.address_line_1 ? this.state.company_info.address_line_1 : null}
                              <br></br>
                              {this.state.company_info.address_line_2 === "" ? this.state.company_info.address_line_2 : null}
                              {this.state.company_info.city}, {this.state.company_info.state} {this.state.company_info.zip}
                              <br></br>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-md-2 text-center">
                      <h3>INVOICE DETAILS</h3>
                    </div>
                    <div className="col-md-2 text-md-end" style={{ textAlign: "right !important" }}>
                      <div>
                        <b>Telephone:</b>
                        <br></br>
                        <b>Fax:</b>
                        <br></br>
                        <b>Website:</b>
                        <br></br>
                        <br></br>
                        <br></br>
                        <b>Invoice:</b>
                        <br></br>
                        <b>Invoice Date:</b>
                        <br></br>
                        <b>Due Date:</b>
                      </div>
                    </div>
                    <div className="col-md-3 text-md-end">
                      <div>{this.state.company_info.telephone}</div>
                      <div>{this.state.company_info.fax}</div>
                      <div>{this.state.company_info.website}</div>
                      <br></br>
                      <br></br>
                      <div>{this.state.invoice && this.state.invoice.id === -1 ? "Not yet saved" : <strong># {this.state.invoice.name}</strong>}</div>
                      <div>{moment.utc(this.props.MakeDateTimeReadable(this.state.invoice.invoiced_at)).format("LL")}</div>
                      <div>{moment.utc(this.props.MakeDateTimeReadable(this.state.invoice.due_at)).format("LL")}</div>
                    </div>
                  </div>
                  <hr className="my-4"></hr>
                  <div className="row mb-4" style={{ marginLeft: ".9in" }}>
                    <div className="col-md-6">
                      <strong>{this.state.client.name}</strong>
                      <p>
                        {this.state.client.address_line_1}
                        <br></br>
                        {this.state.client.address_line_2 === "" ? null : (
                          <span>
                            {this.state.client.address_line_2}
                            <br></br>
                          </span>
                        )}
                        {this.state.client.city ? this.state.client.city + ", " + this.state.client.state + " " + this.state.client.zip : ""}
                        <br></br>
                      </p>
                    </div>
                    <div className="col-md-6 text-md-end"></div>
                  </div>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Comments</th>
                        <th className="text-end">Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.billed_times.map((e, i) => {
                        return (
                          <tr key={i}>
                            <td style={{ verticalAlign: "text-top" }}>{this.props.MakeDateTimeReadable(e.time_at)}</td>
                            <td style={{ verticalAlign: "text-top" }}>{e.time_by}</td>
                            <td style={{ verticalAlign: "text-top", whiteSpace: "pre-line" }}>{e.comments}</td>
                            <td style={{ verticalAlign: "text-top" }} className="text-end">
                              {this.props.FormatNumberTwoDecimals(e.hours)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th></th>
                        <th></th>
                        <th className="text-end">Total:</th>
                        <th className="text-end">{this.state.billed_times.length > 0 ? FormatNumberTwoDecimals(this.state.billed_times.reduce((a, b) => a + b.hours, 0)) : null}</th>
                      </tr>
                    </tfoot>
                  </table>
                  <div className="text-center">
                    <p className="text-sm">
                      <strong>Thank you for your business!</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Offcanvas */}
        <div
          className="offcanvas offcanvas-end"
          style={{ maxWidth: "50%", width: "650px" }}
          data-bs-scroll="true"
          data-bs-backdrop="false"
          tabIndex="-1"
          id="offCanvasContacts"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasScrollingLabel">
              Email Invoice
            </h5>
            <button type="button" id="invoicePanelClose" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="m-3">
            <div className="row mb-3">
              <div className="col-md-3 my-auto">
                <label>
                  <b>From:</b>
                </label>
              </div>
              <div className="col-md-7 mb-2 mt-2">
                <ReactSelect
                  name="form-field-name"
                  id="email-to-select"
                  placeholder="Email From"
                  noOptionsMessage={() => "You don't have any authenticated senders set up. Please click the plus button to add a verified sender."}
                  options={this.state["authenticated_senders"].map((c) => ({ label: c.email, value: c.email }))}
                  onChange={(e) => {
                    this.setState((prevState) => {
                      return {
                        ...prevState,
                        email: {
                          ...prevState.email,
                          from: e.value,
                        },
                      };
                    });
                  }}
                />
              </div>
              <div className="col-md-2 my-auto">
                {/* <ReactTooltip /> */}
                <button className="btn btn-secondary" data-tip="Add new authenticated sender" data-bs-toggle="modal" data-bs-target="#defaultModalNewAuthenticatedSender">
                  <FontAwesomeIcon icon={faUserPlus} />
                </button>
              </div>
              <div className="col-md-3 my-auto">
                <label>
                  <b>To:</b>
                </label>
              </div>
              <div className="col-md-9 mb-2 mt-2">
                <ReactSelect
                  name="form-field-name"
                  id="email-to-select"
                  isMulti={true}
                  placeholder="Email Recipient(s)"
                  noOptionsMessage={() => "None of the contacts for this client have email addresses."}
                  options={this.state["client_contacts"].filter((f) => f.email).map((c) => ({ label: c.name + ": " + c.email, value: c.email }))}
                  onChange={(e) => {
                    this.setState((prevState) => {
                      return {
                        ...prevState,
                        email: {
                          ...prevState.email,
                          to: [
                            ...e.map((f) => {
                              return f.value;
                            }),
                          ],
                        },
                      };
                    });
                  }}
                />
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-12 text-right">
                <button className="btn btn-primary" id="email_invoice" onClick={this.SendInvoiceViaEmail}>
                  <FontAwesomeIcon icon="envelope" /> &nbsp;Send Email
                </button>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-12 text-center">
                {this.state.client.name}'s Link for Invoice #{this.state.invoice.name}:
                <input
                  style={{ marginBottom: "3px" }}
                  disabled={true}
                  className="form-control"
                  value={
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    (window.location.port === "3000" ? ":3000" : "") +
                    "/portal/direct/" +
                    this.state.client.tag +
                    "-" +
                    this.state.invoice.tag
                  }
                ></input>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      window.location.protocol +
                        "//" +
                        window.location.hostname +
                        (window.location.port === "3000" ? ":3000" : "") +
                        "/portal/direct/" +
                        this.state.client.tag +
                        "-" +
                        this.state.invoice.tag,
                    );
                    this.props.MakeNotification("success", "Link copied to clipboard!");
                  }}
                >
                  <FontAwesomeIcon icon="link" />
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* //----------------------------|Confirm Delete Modal|----------------------------\\ */}
        <div className="modal fade" id="defaultModalNewAuthenticatedSender" tabIndex={-1} role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add a New Authenticated Sender</h5>
                <button type="button" id="user-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={this.ModalCloseButton} />
              </div>
              <div className="modal-body m-3">
                <p className="mb-3 text-center">Please enter the email address that you would like to send invoices from.</p>
                <div className="row">
                  <div className="col-md-6 offset-md-3">
                    <label className="col-form-label-sm">E-mail Address</label>
                    <input className="form-control" value={this.state.new_authenticated_sender_email} onChange={(e) => this.setState({ new_authenticated_sender_email: e.target.value })}></input>
                  </div>
                </div>
                <p className="mb-3 mt-3 text-center" id="auth-sender-success-message">
                  Success! Please check that email address for an email from Amazon Web Services to confirm your ownership of that email address. Once confirmed it can take up to an hour for your
                  authenticated sender to show up.
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-info" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" className="btn btn-success" onClick={this.AddAuthenticatedSender}>
                  Add Authenticated Sender
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InvoiceDetailsPreview;
